/**
 * Created by Ning Jiang on 10/18/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {TombstoneMultiplierController} from "../../multiplier/TombstoneMultiplierController";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {TombstoneFreespinIntroView} from "./TombstoneFreespinIntroView";

export class TombstoneFreespinIntroController extends FreespinIntroController {

    constructor(config:IScreenConfig) {
        super(config);
        (<TombstoneFreespinIntroView>this._view).getPlaySoundCallback(() => this.playFSSound());
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return super.calculateIsTriggered(data) && data.nextMode === GameMode.FREESPIN;
    }

    protected doTransitions():void {
        if(this.shouldShow()) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.GUNSLINGER_INTRO);
        } else {
            this.playFSSound();
        }
    }

    protected onCloseComplete():void {
        super.onCloseComplete();
        EventHandler.dispatchEvent(new GameEvent(TombstoneMultiplierController.SHOW_END_MULTIPLIER, !(this._isRestoreFreespin && !this._isFreespinWon)));

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }

    private playFSSound():void {
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.playAmbience(TombstoneSoundConfig.instance.GUNSLINGER_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 0);
    }
}